export default __webpack_public_path__ + "static/media/45Dimic.9023d01a.jpg";